import {useTranslation} from "react-i18next";
import {AiOutlineArrowDown, AiOutlineArrowUp} from "react-icons/ai";
import CO2SavingsChart from "../CO2-Savings/Components/CO2SavingsChart";
import CostSavings from "../CO2-Savings/Components/CostSavings";
import WasteGeneration from "../Waste-Dashboard/Components/Waste-Generation/WasteGeneration";
import BinLineChart from "../Waste-Dashboard/Components/Bin-Linechart/BinLineChart";
import React, {useEffect, useState} from "react";
import axiosInstance from "../../api/axios";

const WasteGenBinline = ({
                             id,
                             wasteitem,
                             currentWasteItem_,
                             dayvalue,
                             datevalue_,
                             datevalue,
                             selectedButton_,
                             selectedButton,
                             selectedValue_,
                             setSelectedValue_,
                             bin_,
                             language,
                             TotalWasteWeight
                         }) => {

    const {t, i18n} = useTranslation();
    const [totalwasteproduceddata, setTotalWasteProducedData] = useState('');
    const [wasteweight, setWasteWeight] = useState(TotalWasteWeight);
    const [colorwastechart, setColorWasteChart] = useState();
    const [percentagechangewastechart, setPercentageChangeWasteChart] = useState();
    const [binpk, setBinPk] = useState();


    useEffect(() => {
        const fetchData = async () => {
            try {
                const binResponse = await axiosInstance.get('/get_bins');
                const foundData = binResponse.data.find(item => item.unique_identifier === id);
                console.log('binPK ', foundData);
                setBinPk(foundData?.id);

                if (foundData?.id) {
                    const wasteResponse = await axiosInstance.get(`/wastebarchart/${foundData.id}/${dayvalue}`, {
                        params: {
                            wasteitem: currentWasteItem_,

                        }
                    });
                    setPercentageChangeWasteChart(parseFloat(wasteResponse.data?.percentage_change).toFixed(2));
                    setColorWasteChart(wasteResponse.data?.color);
                    setTotalWasteProducedData(wasteResponse.data?.objects);
                    setWasteWeight(wasteResponse.data?.waste_weight);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, [currentWasteItem_, id, dayvalue]);


    const filterlang = () => {

        if (selectedButton === 'year' && '') {
            return "jaar";
        }

        if (selectedButton === '6months') {
            return "6 maanden";
        }

        if (selectedButton === '3months') {
            return "3 maanden";
        }

        if (selectedButton === 'month') {
            return "maanden";
        }

        if (selectedButton === 'week') {
            return "week";
        }

        if (selectedButton === 'day') {
            return "dag";
        }

        if (selectedButton === 'custom') {
            return "aangepast";
        }
    };


    return (
        <div style={{minHeight: "50vh"}} className="relative">
            <div className="z-40 w-full px-4 h-25 py-4 pt-5">

                <div className="flex flex-col items-center justify-center w-full mb-4">
                    <h2 className="text-2xl font-poppins font-semibold text-center ">
                        {t('totalwastecomparison')} {filterlang()}
                    </h2>
                    <div className="flex items-center justify-center gap-4 mt-2">
                        <span className="font-semibold text-base">
                            {totalwasteproduceddata} <span
                            className="font-light">{t('objectslabel')}</span> | {wasteweight}
                            <span className="font-light"> KG</span>
                        </span>
                        <span
                            className={`text-${colorwastechart}-500 flex items-center justify-center text-sm font-semibold`}>
                            {percentagechangewastechart}% {colorwastechart === "red" ?
                            <AiOutlineArrowUp/> :
                            <AiOutlineArrowDown/>}
                        </span>
                    </div>
                </div>

                <div className="grid lg:grid-cols-7 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 gap-4 pt-10">
                    <div className="col-span-3 px-8">
                        <WasteGeneration id={id} wasteitem={wasteitem} dayvalue={dayvalue}
                                         datevalue={datevalue} selectedButton={selectedButton}/>
                    </div>
                    <div className="col-span-4 mr-10">
                        <BinLineChart
                            id_={id}
                            currentWasteItem_={currentWasteItem_}
                            dayvalue_={dayvalue}
                            datevalue_={datevalue}
                            selectedButton_={selectedButton}
                            selectedValue_={selectedValue_}
                            setSelectedValue_={setSelectedValue_}
                            bin_={bin_}
                            language={language}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default WasteGenBinline;